// extracted by mini-css-extract-plugin
module.exports = {"addressLink":"styles-styles-module--addressLink--3BxlE"};